module.exports = __webpack_public_path__ + "img/ASN Transfers_500x141.43747c04.png";